/** Every tool links to the others: they share their visitors, and crawlers find them all. */
export const TOOLS = [
  { to: "/calcul-date-accouchement", label: "Calcul de la date d'accouchement" },
  { to: "/calcul-date-de-conception", label: "Calcul de la date de conception" },
  { to: "/calcul-semaines-amenorrhee", label: "Calcul des semaines d'aménorrhée" },
  { to: "/grossesse-semaine-par-semaine", label: "La grossesse semaine par semaine" },
  { to: "/calcul-ovulation", label: "Calcul de l'ovulation" },
  { to: "/calendrier-chinois-grossesse", label: "Calendrier chinois de grossesse" },
] as const;
